import { render } from "./IssueIframe.vue?vue&type=template&id=99db3e04"
import script from "./IssueIframe.vue?vue&type=script&lang=js"
export * from "./IssueIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__